export function getSubjectNameById({subjects, id, fallback = '-'}) {
  const subject = subjects.find((item) => item.id === id);
  if (!subject) {
    return fallback;
  }
  const {name, languageCode, subjectType} = subject;
  return getSubjectName(name, languageCode, subjectType) || fallback;
}

export function getSubjectName(name, languageCode, subjectType) {
  if (languageCode !== '') {
    name += ` (${languageCode})`;
  }
  if (subjectType) {
    if (subjectType === 'tutorial' || subjectType === 'intensive') {
      subjectType = `- ${subjectType?.toUpperCase()}`;
    } else {
      subjectType = `- ${
        subjectType
          ? subjectType.charAt(0).toUpperCase() + subjectType.slice(1)
          : ''
      }`;
    }
    name += ` ${subjectType}`;
  }
  return name;
}

export function getOnlySubjectName({subjects, id, fallback = ''}) {
  var subject = subjects.find((item) => item.id === id);
  var subjectName = subject?.name || fallback;
  return subjectName;
}
